interface CarouselItem {
  title: string;
  desc: string;
  tag: string;
  imageUrl: string;
  imageAlt: string;
}

const carouselItems: CarouselItem[] = [
  {
    title: '韩漫精选 · 恋爱甜宠专场',
    desc: '霸道总裁、契约婚姻、先婚后爱……精选30部高甜韩漫，让你一次嗑到饱。从《霸道总裁的契约新娘》到《重生之逆天改命》，每一部都让人欲罢不能。',
    tag: '韩漫',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20Korean%20manhwa%20themed%20banner%20illustration%2C%20multiple%20elegant%20couples%20in%20various%20romantic%20settings%2C%20soft%20golden%20lighting%20with%20sparkling%20effects%2C%20warm%20pink%20and%20amber%20color%20gradient%2C%20clean%20modern%20composition%20with%20decorative%20elements%2C%20editorial%20design%20quality%2C%20inviting%20and%20warm%20atmosphere&width=1200&height=600&seq=carousel-01&orientation=landscape',
    imageAlt: '韩漫恋爱甜宠专场',
  },
  {
    title: '国漫崛起 · 玄幻武侠盛宴',
    desc: '从《剑道至尊》到各路仙侠大作，国漫以精湛画风与深厚文化底蕴征服读者。这里有最燃的修行之路、最热血的江湖故事。',
    tag: '国漫',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20themed%20banner%20illustration%20with%20martial%20arts%20fantasy%20aesthetic%2C%20warriors%20in%20flowing%20robes%20with%20swords%20in%20misty%20mountain%20landscapes%2C%20ink%20wash%20painting%20style%20blended%20with%20digital%20art%2C%20warm%20earthy%20tones%20with%20jade%20green%20accents%2C%20epic%20composition%20with%20clouds%20and%20ancient%20architecture%2C%20editorial%20quality&width=1200&height=600&seq=carousel-02&orientation=landscape',
    imageAlt: '国漫玄幻武侠盛宴',
  },
  {
    title: '日漫经典 · 热血与治愈同行',
    desc: '从《咒术战线》的热血战斗到《放学后的秘密》的校园纯爱，日漫专区覆盖全类型。每日更新经典与新作，日语原版与中文译本同步上线。',
    tag: '日漫',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20themed%20banner%20illustration%20with%20diverse%20anime%20style%20characters%2C%20action%20scenes%20and%20slice%20of%20life%20moments%20combined%2C%20cherry%20blossoms%20and%20dynamic%20energy%20effects%2C%20warm%20sunset%20lighting%20with%20vibrant%20colors%2C%20clean%20modern%20composition%2C%20high%20quality%20digital%20art%20with%20editorial%20design&width=1200&height=600&seq=carousel-03&orientation=landscape',
    imageAlt: '日漫经典热血治愈',
  },
  {
    title: '暑期狂欢 · 限时免费阅读季',
    desc: '全站2000+部热门漫画限时免费开放，新用户注册即享30天VIP体验。韩漫日漫国漫随心看，这个夏天沉浸在漫画的世界里！',
    tag: '活动',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20vibrant%20summer%20themed%20comic%20promotion%20banner%2C%20colorful%20comic%20panels%20floating%20in%20a%20bright%20summer%20setting%2C%20tropical%20elements%20like%20palm%20leaves%20and%20sunlight%2C%20festive%20and%20energetic%20atmosphere%2C%20warm%20coral%20and%20golden%20yellow%20color%20palette%2C%20clean%20promotional%20design%2C%20editorial%20quality%20digital%20illustration&width=1200&height=600&seq=carousel-04&orientation=landscape',
    imageAlt: '暑期狂欢限时免费',
  },
  {
    title: '新番速递 · 每周新作推荐',
    desc: '本周新增12部独家引进韩漫与6部热门日漫新连载。从奇幻穿越到悬疑推理，每周都有新鲜好漫等你发现。',
    tag: '新番',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20fresh%20and%20modern%20comic%20new%20release%20banner%20illustration%2C%20multiple%20new%20manga%20and%20manhwa%20cover%20art%20arranged%20in%20a%20dynamic%20layout%2C%20fresh%20green%20and%20warm%20amber%20color%20scheme%2C%20clean%20modern%20design%20with%20soft%20gradients%2C%20new%20and%20exciting%20vibe%2C%20editorial%20quality%20digital%20art%20with%20professional%20composition&width=1200&height=600&seq=carousel-05&orientation=landscape',
    imageAlt: '新番速递每周推荐',
  },
  {
    title: 'APP专享 · 离线追漫更自由',
    desc: '下载贝勒漫画APP享受专属权益：离线下载、夜间模式、无广告阅读、自动追更提醒。随时随地，漫画就在口袋里。',
    tag: 'APP',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20app%20promotion%20banner%2C%20a%20phone%20floating%20in%20center%20displaying%20colorful%20manga%20pages%2C%20surrounded%20by%20comic%20panels%20and%20speech%20bubbles%2C%20warm%20cozy%20reading%20atmosphere%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20clean%20modern%20marketing%20design%2C%20editorial%20quality%20digital%20illustration&width=1200&height=600&seq=carousel-06&orientation=landscape',
    imageAlt: 'APP专享离线追漫',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">焦点专题</h2>
          <p className="text-sm text-foreground-500">精选漫画专题合集，发现你的下一部心头好</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group relative rounded-xl overflow-hidden bg-background-200 border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-base font-heading text-background-50 mb-1.5">{item.title}</h3>
                  <p className="text-xs text-background-50/75 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}